// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ReportVO')
export class ReportVO {
  public static readonly TYPE_PDF: string = 'pdf';
  public static readonly TYPE_CSV: string = 'csv';

  @JsonProperty('id', 'String')
  public id: string = undefined;

  @JsonProperty('groupId', 'String')
  public groupId: string = undefined;

  @JsonProperty('name', 'String')
  public name: string = undefined;

  @JsonProperty('path', 'String')
  public path: string = undefined;

  @JsonProperty('userGroupNames', '[String]')
  public userGroupNames: string[] = undefined;

  @JsonProperty('selected', 'Boolean')
  public selected: boolean = undefined;

  @JsonProperty('editable', 'Boolean')
  public editable: boolean = undefined;

  @JsonProperty('type', 'String')
  public type: string = undefined;

  @JsonProperty('subreports', 'Object')
  public subreports: Object = undefined;

  @JsonProperty('templates', '[String]')
  public templates: string[] = undefined;

  @JsonProperty('scale', 'Number')
  public scale: number = 1;

  public subtype: string = undefined;

  // override default object method toJSON() (which is invoked when the object should be serialize)
  // to exclude transient properties and send correct object to server
  public toJSON() {
    return {
      id: this.id,
      groupId: this.groupId,
      name: this.name,
      path: this.path,
      userGroupNames: this.userGroupNames,
      selected: this.selected,
      editable: this.editable,
      type: this.type,
      subreports: this.subreports,
      templates: this.templates,
      scale: this.scale,
    };
  }
}

@JsonObject('PdfExportJournalEntityVO')
export class PdfExportJournalEntityVO {

  @JsonProperty('contentId', 'String')
  public contentId: string = undefined;

  @JsonProperty('projectId', 'number')
  public projectId: number = undefined;

  @JsonProperty('userId', 'number')
  public userId: number = undefined;

  @JsonProperty('paperSize', 'String')
  public paperSize: string = undefined;

  @JsonProperty('templatesAndScales', 'String')
  public templatesAndScales: string = undefined;

  @JsonProperty('jobStart', 'String')
  public jobStart: string = undefined;

  @JsonProperty('jobStatus', 'String')
  public editable: string = undefined;

  @JsonProperty('jobEnd', 'String')
  public jobEnd: string = undefined;

  @JsonProperty('pdfSize', 'number')
  public pdfSize: number = undefined;

  @JsonProperty('projectName', 'string')
  public projectName: string = undefined;
}
